import { Typography } from '@metrika/ui-kit';
import { styled } from '@metrika/ui-kit/emotion';
import { Search } from '@metrika/ui-kit/icons/carbon';
import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Overlay, SearchOverlay } from './SearchOverlay';
import { useSearchIndex } from './useSearchIndex';

export const IconButton = styled.div`
   background: none;
   border: none;
   padding: 0.5rem;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: color 0.2s;

   &:hover {
      color: ${(props) => (props.theme.name === 'dark' ? props.theme.colors.focusInverse : props.theme.colors.focus)};
   }

   svg {
      width: 20px;
      height: 20px;
   }
`;

export const SearchWrapper = styled.div`
   margin-right: 16px;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: color 0.2s;

   &:hover {
      span,
      svg {
         color: ${(props) =>
            props.theme.name === 'dark' ? props.theme.colors.focusInverse : props.theme.colors.focus} !important;
      }
   }

   svg {
      width: 20px;
      height: 20px;
   }
`;

export const SearchButton: React.FC = () => {
   const [isSearchOpen, setIsSearchOpen] = useState(false);

   const handleOpenSearch = useCallback(() => {
      setIsSearchOpen(true);
   }, []);

   const handleCloseSearch = useCallback(() => {
      setIsSearchOpen(false);
   }, []);

   //init index early
   useSearchIndex();

   const handleKeyDown = useCallback(
      (event: KeyboardEvent) => {
         if ((event.metaKey || event.ctrlKey) && event.key === 'f') {
            event.preventDefault();
            handleOpenSearch();
         }
      },
      [handleOpenSearch],
   );

   useEffect(() => {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
   }, [handleKeyDown]);

   const handleOverlayClick = useCallback(
      (event: React.MouseEvent) => {
         if (event.target === event.currentTarget) {
            handleCloseSearch();
         }
      },
      [handleCloseSearch],
   );

   return (
      <>
         <SearchWrapper onClick={handleOpenSearch}>
            <IconButton aria-label="Open search" title="Search">
               <Search size={32} />
            </IconButton>
            <Typography as={'span'} variant="bodyShort01">
               Search ...
            </Typography>
         </SearchWrapper>
         {createPortal(
            <Overlay isVisible={isSearchOpen} onClick={handleOverlayClick}>
               {isSearchOpen && <SearchOverlay isOpen={isSearchOpen} onClose={handleCloseSearch} />}
            </Overlay>,
            document.body,
         )}
      </>
   );
};
